import { render, staticRenderFns } from "./SignupDataComplete.vue?vue&type=template&id=35f5c30c"
import script from "./SignupDataComplete.vue?vue&type=script&lang=js"
export * from "./SignupDataComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports